'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 5,
    bottom: 5,
    left: 90,
    right: 10
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding
  };
};
module.exports = Params;